module.exports = __webpack_public_path__ + "img/logo_whd.2a03cd31.png";